import { MultiString } from "../../../i18n/MultiString";

export abstract class LomaInfo
{
  info:MultiString;

  setInfo( info:MultiString )
  {
    this.info = info;
    return this;  
  }

  abstract getInfoTitle():string; 

  
}